import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetArticleLikesViewsResponseBody } from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseArticleLikesViewsQueryValues = {
  appId: string;
  articleId: string;
};

export const articleLikesViewsQueryKeyFactory: IQueryKeyFactory<
  IUseArticleLikesViewsQueryValues
> = (values) =>
  values && (['articleLikesViews', values.appId, values.articleId] as const);

export const useArticleLikesViewsQuery = (
  values?: IUseArticleLikesViewsQueryValues,
  options?: UseQueryOptions<IApiGetArticleLikesViewsResponseBody, ApiError>,
): UseQueryResult<IApiGetArticleLikesViewsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: articleLikesViewsQueryKeyFactory(values),
    queryFn: values
      ? () => api.articles.getLikesViews(values.appId, values.articleId)
      : undefined,
    enabled: !!values,
    retry: options?.retry ?? 1,
    retryDelay: options?.retryDelay ?? 500,
    ...options,
  });
};
